<template>
  <div class="mt-3 py-5">
    <b-container>

      <!-- 一般 メイン -->
      <template v-if="String(user.user_type) == '1'">
        <!-- 一般 サイドメニュー -->
        <aside>
          <b-sidebar
            id="sidebar-backdrop"
            backdrop
            shadow
            no-header
            sidebar-class="border-right"
            width="250px"
          >
            <b-list-group flush>
              <b-list-group-item><a @click="c_switch(1)">メインページ</a></b-list-group-item>
              <b-list-group-item><a @click="c_switch(2)">プロフィール</a></b-list-group-item>
              <b-list-group-item><a @click="c_switch(3)">購入申し込み管理</a></b-list-group-item>
              <b-list-group-item><a @click="c_switch(4)">試弾申し込み管理</a></b-list-group-item>
              <b-list-group-item><a @click="c_switch(5)">メッセージ</a></b-list-group-item>
              <b-list-group-item><a @click="c_switch(6)">レビュー</a></b-list-group-item>
              <b-list-group-item><a @click="c_switch(7)">お気に入り</a></b-list-group-item>
              <b-list-group-item><a @click="c_switch(8)">コメント</a></b-list-group-item>
            </b-list-group>
          </b-sidebar>
        </aside>
        <div class="row m-0">
            <div class="side-bar col-md-3 d-pc">
              <div>
                <ul class="sidenav">
                  <li><a v-bind:class="{ active: component_switch == 1 }" class="" href="javascript:void(0);" @click="c_switch(1)">メインページ</a></li>
                  <li><a v-bind:class="{ active: component_switch == 2 }" class="" href="javascript:void(0);" @click="c_switch(2)">プロフィール</a></li>
                  <li><a v-bind:class="{ active: component_switch == 3 }" class="" href="javascript:void(0);" @click="c_switch(3)">購入申し込み管理</a></li>
                  <li><a v-bind:class="{ active: component_switch == 4 }" class="" href="javascript:void(0);" @click="c_switch(4)">試弾申し込み管理</a></li>
                  <li><a v-bind:class="{ active: component_switch == 5 }" class="" href="javascript:void(0);" @click="c_switch(5)">メッセージ</a></li>
                  <li><a v-bind:class="{ active: component_switch == 6 }" class="" href="javascript:void(0);" @click="c_switch(6)">レビュー</a></li>
                  <li><a v-bind:class="{ active: component_switch == 7 }" class="" href="javascript:void(0);" @click="c_switch(7)">お気に入り</a></li>
                  <li><a v-bind:class="{ active: component_switch == 8 }" class="" href="javascript:void(0);" @click="c_switch(8)">コメント</a></li>
                </ul>
              </div>
            </div>
            <div class="main-contents col-md-9">
              <div>
                <buyer-main v-if="component_switch==1" :user="user"></buyer-main>
                <buyer-profile v-if="component_switch==2" :user="user"></buyer-profile>
                <buyer-buy v-if="component_switch==3" :user="user"></buyer-buy>
                <buyer-testbullet v-if="component_switch==4" :user="user"></buyer-testbullet>
                <buyer-message v-if="component_switch==5" :user="user"></buyer-message>
                <buyer-review v-if="component_switch==6" :user="user"></buyer-review>
                <buyer-favorite v-if="component_switch==7" :user="user"></buyer-favorite>
                <buyer-comment v-if="component_switch==8" :user="user"></buyer-comment>
              </div>
            </div>
        </div>
      </template>

      <!-- 販売者 メイン -->
      <template v-if="String(user.user_type) == '2'">
        <template v-if="String(user.input_status) == '9'">
          <!-- 販売者 サイドメニュー -->
          <aside>
            <b-sidebar
              id="sidebar-backdrop"
              backdrop
              shadow
              no-header
              sidebar-class="border-right"
              width="250px"
            >
              <b-list-group flush>
                <b-list-group-item><a @click="c_switch(1)">メインページ</a></b-list-group-item>
                <b-list-group-item><a @click="c_switch(3)">プロフィール</a></b-list-group-item>
                <template v-if="String(user.identification_flg) != '3'">
                  <b-list-group-item><a @click="c_switch(9)">本人確認</a></b-list-group-item>
                </template>
                <template v-else>
                  <b-list-group-item><a @click="c_switch(2)">商品管理</a></b-list-group-item>
                  <b-list-group-item><a @click="c_switch(4)">購入申し込み管理</a></b-list-group-item>
                  <b-list-group-item><a @click="c_switch(5)">試弾申し込み管理</a></b-list-group-item>
                  <b-list-group-item><a @click="c_switch(6)">メッセージ</a></b-list-group-item>
                  <b-list-group-item><a @click="c_switch(7)">コメント管理</a></b-list-group-item>
                  <b-list-group-item><a @click="c_switch(11)">支払い管理</a></b-list-group-item>
                  <b-list-group-item><a @click="c_switch(8)">スタッフ管理</a></b-list-group-item>
                  <b-list-group-item><a @click="c_switch(10)">レビュー</a></b-list-group-item>
                </template>
              </b-list-group>
            </b-sidebar>
          </aside>
          <!-- 販売者マイページ -->
          <div class="row m-0">
            <div class="side-bar col-md-3 d-pc">
              <div>
                <ul class="sidenav">
                  <li><a v-bind:class="{ active: component_switch == 1 }" class="" href="javascript:void(0);" @click="c_switch(1)">メインページ</a></li>
                  <li><a v-bind:class="{ active: component_switch == 3 }" class="" href="javascript:void(0);" @click="c_switch(3)">プロフィール</a></li>
                  <template v-if="String(user.identification_flg) != '3'">
                    <li><a v-bind:class="{ active: component_switch == 9 }" class="" href="javascript:void(0);" @click="c_switch(9)">本人確認</a></li>
                  </template>
                  <template v-else>
                    <li><a v-bind:class="{ active: component_switch == 2 }" class="" href="javascript:void(0);" @click="c_switch(2)">商品管理</a></li>
                    <li><a v-bind:class="{ active: component_switch == 4 }" class="" href="javascript:void(0);" @click="c_switch(4)">購入申し込み管理</a></li>
                    <li><a v-bind:class="{ active: component_switch == 5 }" class="" href="javascript:void(0);" @click="c_switch(5)">試弾申し込み管理</a></li>
                    <li><a v-bind:class="{ active: component_switch == 6 }" class="" href="javascript:void(0);" @click="c_switch(6)">メッセージ</a></li>
                    <li><a v-bind:class="{ active: component_switch == 7 }" class="" href="javascript:void(0);" @click="c_switch(7)">コメント管理</a></li>
                    <li><a v-bind:class="{ active: component_switch == 11 }" class="" href="javascript:void(0);" @click="c_switch(11)">支払い管理</a></li>
                    <li><a v-bind:class="{ active: component_switch == 8 }" class="" href="javascript:void(0);" @click="c_switch(8)">スタッフ管理</a></li>
                    <li><a v-bind:class="{ active: component_switch == 10 }" class="" href="javascript:void(0);" @click="c_switch(10)">レビュー</a></li>
                  </template>
                </ul>
              </div>
            </div>
            <div class="main-contents col-md-9">
              <div>
                <seller-main v-if="component_switch==1" :user="user"></seller-main>
                <seller-product v-if="component_switch==2" :user="user"></seller-product>
                <seller-profile v-if="component_switch==3" :user="user"></seller-profile>
                <seller-buy v-if="component_switch==4" :user="user"></seller-buy>
                <seller-testbullet v-if="component_switch==5" :user="user"></seller-testbullet>
                <seller-message v-if="component_switch==6" :user="user"></seller-message>
                <seller-comment v-if="component_switch==7" :user="user"></seller-comment>
                <seller-payment v-if="component_switch==11" :user="user"></seller-payment>
                <seller-staff v-if="component_switch==8" :user="user"></seller-staff>
                <seller-identification v-if="component_switch==9" :user="user"></seller-identification>
                <seller-review v-if="component_switch==10" :user="user"></seller-review>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <!-- 販売者初回入力メニュー -->
          <template v-if="( String(user.input_status) == '0' || String(user.input_status) == '1' || String(user.input_status) == '2' || String(user.input_status) == '3' || String(user.input_status) == '4' )">
            <div id="progress" class="row mb-5 text-center mx-1">
              <div class="col-2 li my-2" v-bind:class="{ active: String(user.input_status) == '0' }">
                <span>1. 法人情報</span>
              </div>
              <div class="col-2 text-center my-2">
                →
              </div>
              <div class="col-2 li my-2" v-bind:class="{ active: String(user.input_status) == '1' }">
                <span>2. 販売者情報</span>
              </div>
              <div class="col-2 text-center my-2">
                →
              </div>
              <div class="col-2 li my-2" v-bind:class="{ active: String(user.input_status) == '2' }">
                <span>3. 公開情報</span>
              </div>
              <div class="col-2 text-center my-2">
                →
              </div>
              <div class="col-2 li my-2" v-bind:class="{ active: String(user.input_status) == '3' }">
                <span>4. 共通情報</span>
              </div>
              <div class="col-2 text-center my-2">
                →
              </div>
              <div class="col-2 li my-2" v-bind:class="{ active: String(user.input_status) == '4' }">
                <span>完了</span>
              </div>
            </div>
            <b-row>
              <b-col cols="12" md="8" class="m-auto px-3">
                <div class="">
                  <div class="pt-2 pb-5">
                    <!-- 販売者 -->
                    <template v-if="String(user.input_status) == '0'">
                      <!-- 法人 -->
                      <div class="card">
                        <!-- <div class="card-header">相談所　公開プロフィール情報登録</div> -->

                        <div class="card-body step1"> 
                          <h4 class="mb-5">〇 STEP1.　法人格の確認情報</h4>
                          <div class=""> 
                            <div class="form-group">
                              <label for="legal_person" class="col-sm-10 control-label">法人格の確認と情報  <span class="required_mark">必須</span></label>
                              <div class="col-sm-10">
                                  <label class="checkbox-inline p-3">
                                      <input type="radio" v-model="form1.legal_person" value="1">
                                      法人格を持つ
                                  </label>
                                  <label class="checkbox-inline p-3">
                                      <input type="radio" v-model="form1.legal_person" value="0">
                                      法人格を持たない
                                  </label>
                              </div>
                            </div>
                          </div>

                          <div class="" v-show="String(form1.legal_person) == '1'">
                              <!-- <div class="card-header"></div> -->
                              <div class="mb-5"> 
                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">法人(企業)名  <span class="required_mark">必須</span></label>
                                          <input type="text" placeholder="" v-model="form1.corp_name" class="required form-control" v-bind:class="{ error_input: form1.errors.corp_name.length > 0 }">
                                          <div v-if="form1.errors.corp_name.length > 0">
                                            <div class="error-text" v-for="(item, index) in form1.errors.corp_name" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">法人代表者(責任者)の氏名  <span class="required_mark">必須</span></label>
                                          <input type="text" placeholder="" v-model="form1.corp_representative" class="required form-control" v-bind:class="{ error_input: form1.errors.corp_representative.length > 0 }">
                                          <div v-if="form1.errors.corp_representative.length > 0">
                                            <div class="error-text" v-for="(item, index) in form1.errors.corp_representative" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">郵便番号(半角数字)  <span class="required_mark">必須</span>　<a target="_blank" href="https://yu-bin.jp/zipcode/">郵便番号検索</a></label>
                                          <input type="tel" placeholder="" v-model="form1.corp_postalcode" class="required form-control" maxlength="8" v-bind:class="{ error_input: form1.errors.corp_postalcode.length > 0 }">
                                          <div v-if="form1.errors.corp_postalcode.length > 0">
                                            <div class="error-text" v-for="(item, index) in form1.errors.corp_postalcode" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>
        
                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">住所  <span class="required_mark">必須</span></label>
                                          <input type="text" placeholder="" v-model="form1.corp_address" class="required form-control" v-bind:class="{ error_input: form1.errors.corp_address.length > 0 }">
                                          <div v-if="form1.errors.corp_address.length > 0">
                                            <div class="error-text" v-for="(item, index) in form1.errors.corp_address" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>
        
                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">電話番号</label>
                                          <input type="tel" placeholder="" v-model="form1.corp_phone_number" class="form-control" v-bind:class="{ error_input: form1.errors.corp_phone_number.length > 0 }">
                                          <div v-if="form1.errors.corp_phone_number.length > 0">
                                            <div class="error-text" v-for="(item, index) in form1.errors.corp_phone_number" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>
        
                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">活動実績のわかるURL</label>
                                          <input type="text" placeholder="" v-model="form1.hp_url" class="form-control" v-bind:class="{ error_input: form1.errors.hp_url.length > 0 }">
                                          <div v-if="form1.errors.hp_url.length > 0">
                                            <div class="error-text" v-for="(item, index) in form1.errors.hp_url" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>
        
                              </div>
                          </div>
        
                          <div class="form-group">
                              <div class="b100 col-sm-12">
                                  <button type="button" class="bs100 btn btn-primary" @click="form1_submit()">次へ</button>
                                  <!-- <input class="bs100 btn btn-primary" type="submit" value="次へ"> -->
                              </div>
                          </div>
        
                        </div>

                      </div>
                    </template>
                    <template v-if="String(user.input_status) == '1'">
                      <!-- ピアノ販売者 アカウントの作成 -->
                      <div class="card">
                        <!-- <div class="card-header">相談所　公開プロフィール情報登録</div> -->

                        <div class="card-body step1"> 
                          <h4 class="mb-5">〇 STEP2.　ピアノ販売者 アカウントの作成</h4>
                          <div class="">
                              <!-- <div class="card-header"></div> -->
                              <div class="mb-5"> 

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">ピアノ販売業の屋号（〇〇ピアノサービス etc）  <span class="required_mark">必須</span></label>
                                          <input type="text" placeholder="ハッピー・ピアノサービス" v-model="form2.store_name" class="required form-control" v-bind:class="{ error_input: form2.errors.store_name.length > 0 }">
                                          <div v-if="form2.errors.store_name.length > 0">
                                            <div class="error-text" v-for="(item, index) in form2.errors.store_name" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">郵便番号(半角数字)  <span class="required_mark">必須</span>　<a target="_blank" href="https://yu-bin.jp/zipcode/">郵便番号検索</a></label>
                                          <input type="tel" placeholder="" v-model="form2.postal_code" class="required form-control" maxlength="8" v-bind:class="{ error_input: form2.errors.postal_code.length > 0 }">
                                          <div v-if="form2.errors.postal_code.length > 0">
                                            <div class="error-text" v-for="(item, index) in form2.errors.postal_code" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>
        
                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">都道府県  <span class="required_mark">必須</span></label>
                                          <input type="text" placeholder="" v-model="form2.region" class="required form-control" v-bind:class="{ error_input: form2.errors.region.length > 0 }">
                                          <div v-if="form2.errors.region.length > 0">
                                            <div class="error-text" v-for="(item, index) in form2.errors.region" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">住所１　(市区町村)  <span class="required_mark">必須</span></label>
                                          <input type="text" placeholder="" v-model="form2.address_1" class="required form-control" v-bind:class="{ error_input: form2.errors.address_1.length > 0 }">
                                          <div v-if="form2.errors.address_1.length > 0">
                                            <div class="error-text" v-for="(item, index) in form2.errors.address_1" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">住所２　(番地、建物名)  <span class="required_mark">必須</span></label>
                                          <input type="text" placeholder="" v-model="form2.address_2" class="required form-control" v-bind:class="{ error_input: form2.errors.address_2.length > 0 }">
                                          <div v-if="form2.errors.address_2.length > 0">
                                            <div class="error-text" v-for="(item, index) in form2.errors.address_2" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">電話番号</label>
                                          <input type="tel" placeholder="" v-model="form2.phone" class="form-control" v-bind:class="{ error_input: form2.errors.phone.length > 0 }">
                                          <div v-if="form2.errors.phone.length > 0">
                                            <div class="error-text" v-for="(item, index) in form2.errors.phone" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">活動実績のわかるURL</label>
                                          <input type="text" placeholder="" v-model="form2.blog_url" class="form-control" v-bind:class="{ error_input: form2.errors.blog_url.length > 0 }">
                                          <div v-if="form2.errors.blog_url.length > 0">
                                            <div class="error-text" v-for="(item, index) in form2.errors.blog_url" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                                  <!-- <h4 style="background-color: #9affab;" class="m-3 p-3">代表者の情報</h4> -->

                                  <div class="form-group row mx-0">
                                      <div class="px-1 col-6">
                                          <label class="col-sm-6 control-label">姓  <span class="required_mark">必須</span></label>
                                          <input type="text" placeholder="山本" v-model="form2.last_name" class="required form-control" v-bind:class="{ error_input: form2.errors.last_name.length > 0 }">
                                          <div v-if="form2.errors.last_name.length > 0">
                                            <div class="error-text" v-for="(item, index) in form2.errors.last_name" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                      <div class="px-1 col-6">
                                          <label class="col-sm-6 control-label">名  <span class="required_mark">必須</span></label>
                                          <input type="text" placeholder="太郎" v-model="form2.first_name" class="required form-control" v-bind:class="{ error_input: form2.errors.first_name.length > 0 }">
                                          <div v-if="form2.errors.first_name.length > 0">
                                            <div class="error-text" v-for="(item, index) in form2.errors.first_name" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="form-group row mx-0">
                                      <div class="px-1 col-6">
                                          <label class="col-sm-6 control-label">セイ  <span class="required_mark">必須</span></label>
                                          <input type="text" placeholder="" v-model="form2.phonetic_last_name" class="required form-control" v-bind:class="{ error_input: form2.errors.phonetic_last_name.length > 0 }">
                                          <div v-if="form2.errors.phonetic_last_name.length > 0">
                                            <div class="error-text" v-for="(item, index) in form2.errors.phonetic_last_name" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                      <div class="px-1 col-6">
                                          <label class="col-sm-6 control-label">メイ  <span class="required_mark">必須</span></label>
                                          <input type="text" placeholder="" v-model="form2.phonetic_first_name" class="required form-control" v-bind:class="{ error_input: form2.errors.phonetic_first_name.length > 0 }">
                                          <div v-if="form2.errors.phonetic_first_name.length > 0">
                                            <div class="error-text" v-for="(item, index) in form2.errors.phonetic_first_name" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">性別  <span class="required_mark">必須</span></label>
                                          <div class="col-sm-10">
                                          <label class="checkbox-inline p-3">
                                              <input type="radio" v-model="form2.gender" value="1">
                                              男性
                                          </label>
                                          <label class="checkbox-inline p-3">
                                              <input type="radio" v-model="form2.gender" value="2">
                                              女性
                                          </label>
                                      </div>
                                  </div>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">生年月日  <span class="required_mark">必須</span></label>
                                          <input type="date" placeholder="" v-model="form2.old" class="required form-control" v-bind:class="{ error_input: form2.errors.old.length > 0 }">
                                          <div v-if="form2.errors.old.length > 0">
                                            <div class="error-text" v-for="(item, index) in form2.errors.old" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                              </div>
                          </div>
        
                          <div class="form-group">
                              <div class="b100 col-sm-12">
                                  <button type="button" class="bs100 btn btn-primary" @click="form2_submit()">次へ</button>
                                  <!-- <input class="bs100 btn btn-primary" type="submit" value="次へ"> -->
                              </div>
                          </div>
        
                        </div>

                      </div>
                    </template>
                    <template v-if="String(user.input_status) == '2'">
                      <!-- 公開ページの基礎情報 -->
                      <div class="card">
                        <!-- <div class="card-header">相談所　公開プロフィール情報登録</div> -->

                        <div class="card-body step1"> 
                          <h4 class="mb-5">〇 STEP3.　公開ページの基礎情報</h4>
                          <div class="">
                              <!-- <div class="card-header"></div> -->
                              <div class="mb-5"> 

                                  <div class="form-group">

                                      <div class="col-sm-12 px-1">
                                          <label for="" class="col-sm-12 control-label">メイン画像 推奨サイズ(600px X 800px)<span class="required_mark">1枚必須</span></label>
                                          <div class="row mt-2 mb-2 mx-0">
                                              <div class="col-sm-3">
                                                  <div style="border: solid 1px #bab7b7;border-radius: 4px;min-height: 100px;width: auto;" class="mb-2" v-bind:class="{ error_input: form3.errors.image.length > 0 }">
                                                    <img :src="form3.image1" class="my-3">
                                                  </div>
                                                  <label class="col-sm-12 btn btn-warning" @click="uploadImage1">選択</label>
                                                  <input type="file" style="display: none" ref="input1" @change="onImageChange1"/>
                                              </div>
                                              <div class="col-sm-3">
                                                  <div style="border: solid 1px #bab7b7;border-radius: 4px;min-height: 100px;width: auto;" class="mb-2">
                                                    <img :src="form3.image2" class="my-3">
                                                  </div>
                                                  <label class="col-sm-12 btn btn-warning" @click="uploadImage2">選択</label>
                                                  <input type="file" style="display: none" ref="input2" @change="onImageChange2"/>
                                              </div>
                                              <div class="col-sm-3">
                                                  <div style="border: solid 1px #bab7b7;border-radius: 4px;min-height: 100px;width: auto;" class="mb-2">
                                                    <img :src="form3.image3" class="my-3">
                                                  </div>
                                                  <label class="col-sm-12 btn btn-warning" @click="uploadImage3">選択</label>
                                                  <input type="file" style="display: none" ref="input3" @change="onImageChange3"/>
                                              </div>
                                              <div class="col-sm-3">
                                                  <div style="border: solid 1px #bab7b7;border-radius: 4px;min-height: 100px;width: auto;" class="mb-2">
                                                    <img :src="form3.image4" class="my-3">
                                                  </div>
                                                  <label class="col-sm-12 btn btn-warning" @click="uploadImage4">選択</label>
                                                  <input type="file" style="display: none" ref="input4" @change="onImageChange4"/>
                                              </div>
                                          </div>
                                          <div v-if="form3.errors.image.length > 0">
                                            <div class="error-text" v-for="(item, index) in form3.errors.image" :key="index">{{ item }}</div>
                                          </div>
                                      </div>

                                      <div class="col-sm-12 px-1">
                                          <div class="row mt-2 mb-2 mx-0">
                                              <div class="col-sm-3">
                                                  <div style="border: solid 1px #bab7b7;border-radius: 4px;min-height: 100px;width: auto;" class="mb-2">
                                                    <img :src="form3.image5" class="my-3">
                                                  </div>
                                                  <label class="col-sm-12 btn btn-warning" @click="uploadImage5">選択</label>
                                                  <input type="file" style="display: none" ref="input5" @change="onImageChange5"/>
                                              </div>
                                              <div class="col-sm-3">
                                                  <div style="border: solid 1px #bab7b7;border-radius: 4px;min-height: 100px;width: auto;" class="mb-2">
                                                    <img :src="form3.image6" class="my-3">
                                                  </div>
                                                  <label class="col-sm-12 btn btn-warning" @click="uploadImage6">選択</label>
                                                  <input type="file" style="display: none" ref="input6" @change="onImageChange6"/>
                                              </div>
                                              <div class="col-sm-3">
                                                  <div style="border: solid 1px #bab7b7;border-radius: 4px;min-height: 100px;width: auto;" class="mb-2">
                                                    <img :src="form3.image7" class="my-3">
                                                  </div>
                                                  <label class="col-sm-12 btn btn-warning" @click="uploadImage7">選択</label>
                                                  <input type="file" style="display: none" ref="input7" @change="onImageChange7"/>
                                              </div>
                                              <div class="col-sm-3">
                                                  <div style="border: solid 1px #bab7b7;border-radius: 4px;min-height: 100px;width: auto;" class="mb-2">
                                                    <img :src="form3.image8" class="my-3">
                                                  </div>
                                                  <label class="col-sm-12 btn btn-warning" @click="uploadImage8">選択</label>
                                                  <input type="file" style="display: none" ref="input8" @change="onImageChange8"/>
                                              </div>
                                          </div>
                                      </div>

                                      <div class="col-sm-12 px-1">
                                          <div class="row mt-2 mb-2 mx-0">
                                              <div class="col-sm-3">
                                                  <div style="border: solid 1px #bab7b7;border-radius: 4px;min-height: 100px;width: auto;" class="mb-2">
                                                    <img :src="form3.image9" class="my-3">
                                                  </div>
                                                  <label class="col-sm-12 btn btn-warning" @click="uploadImage9">選択</label>
                                                  <input type="file" style="display: none" ref="input9" @change="onImageChange9"/>
                                              </div>
                                              <div class="col-sm-3">
                                                  <div style="border: solid 1px #bab7b7;border-radius: 4px;min-height: 100px;width: auto;" class="mb-2">
                                                    <img :src="form3.image10" class="my-3">
                                                  </div>
                                                  <label class="col-sm-12 btn btn-warning" @click="uploadImage10">選択</label>
                                                  <input type="file" style="display: none" ref="input10" @change="onImageChange10"/>
                                              </div>
                                              <div class="col-sm-3">
                                              </div>
                                              <div class="col-sm-3">
                                              </div>
                                          </div>
                                      </div>

                                    </div>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">一言アピール　（モットーなど、特徴のアピールを30文字以内で）  <span class="required_mark">必須</span></label>
                                          <textarea placeholder="記入例：弾きやすさ、心地よい音質を目指し、最終調整にこだわります！" v-model="form3.slogan" class="required form-control" rows="2" maxlength="30" v-bind:class="{ error_input: form3.errors.slogan.length > 0 }"></textarea>
                                          <div v-if="form3.errors.slogan.length > 0">
                                            <div class="error-text" v-for="(item, index) in form3.errors.slogan" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">事業紹介　（上記の特徴を踏まえ、事業の説明　　1000字以内で）  <span class="required_mark">必須</span></label>
                                          <textarea placeholder="記入例：当社は、設立３０年以来、ピアノの調律、修理、中古ピアノ販売を専業にしております。中古ピアノも現在まで1000台以上をお客様のもとへお届けして参りました。外観だけでなく、内部の状態も良質なピアノだけを厳選しております。

                                              これまで、お子様や初心者の方のためのピアノから、ピアノレスナー様やプロのピアニストの方までご用命いただきました。しかし、初心者の方用のピアノだからといって、調整に手を抜くようなことがあってはなりません。幼少期にできるだけ良いピアノに触れることが、良い音楽性を育みます。それ故、調整には一切の妥協をすることはいたしません。そして、プロの方には、より音楽を感じてもらえるような音作りを目指しております。

                                              そのピアノ本来の良さを発揮させるためには、特にハンマー成形などの最終調整がそのピアノの良し悪しを決定づけると考えております。他社とは一味違う最終調整をされた当社のピアノとご縁があれば
                                              " v-model="form3.Introduction" class="required form-control" rows="10" maxlength="1000" v-bind:class="{ error_input: form3.errors.Introduction.length > 0 }"></textarea>
                                          <div v-if="form3.errors.Introduction.length > 0">
                                            <div class="error-text" v-for="(item, index) in form3.errors.Introduction" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">購入された方への約束について　（500字以内）  <span class="required_mark">必須</span></label>
                                          <textarea placeholder="記入例：最終調整にご満足いただけない場合は、納得できない部分について再調整させていただきます！ご安心ください。" v-model="form3.promiss" class="required form-control" rows="5" maxlength="500" v-bind:class="{ error_input: form3.errors.promiss.length > 0 }"></textarea>
                                          <div v-if="form3.errors.promiss.length > 0">
                                            <div class="error-text" v-for="(item, index) in form3.errors.promiss" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                              </div>
                          </div>
        
                          <div class="form-group">
                              <div class="b100 col-sm-12">
                                  <button type="button" class="bs100 btn btn-primary" @click="form3_submit()">次へ</button>
                                  <!-- <input class="bs100 btn btn-primary" type="submit" value="次へ"> -->
                              </div>
                          </div>
        
                        </div>

                      </div>

                    </template>
                    <template v-if="String(user.input_status) == '3'">
                      <!-- 各商品ページの共通情報 -->

                      <div class="card">
                        <!-- <div class="card-header">相談所　公開プロフィール情報登録</div> -->

                        <div class="card-body step1"> 
                          <h4 class="mb-5">〇 STEP4.　各商品ページの共通情報</h4>
                          <div class="">
                              <!-- <div class="card-header"></div> -->
                              <div class="mb-5"> 

                                  <h5 class="mb-4 pl-2">＜すべての商品に対して行う共通した整備内容＞</h5>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">整備内容の方針、概要</label>
                                          <textarea placeholder="記入例：当社では、外観だけでなく元々内部状態の良い中古ピアノを厳選して、ご提供しております。状態の良い中古ピアノを買い取ってから販売するまで、調律・修理などピアノを奏でるに当たって問題になる箇所をもらさず直していきます。そして納品後に行うハンマー成形により最終仕上げを行います。以下は、当社で行う主な整備内容です。" v-model="form4.maintenance_policy" class="form-control" rows="8" maxlength="" v-bind:class="{ error_input: form4.errors.maintenance_policy.length > 0 }"></textarea>
                                          <div v-if="form4.errors.maintenance_policy.length > 0">
                                            <div class="error-text" v-for="(item, index) in form4.errors.maintenance_policy" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">外側の手入れ</label>
                                          <textarea placeholder="記入例：できるだけ本来の艶がでるところまで磨きをかけます。 キズに関しては、低価格でご提供するため大きな傷のみ塗装処理をいたします。ペダルやブランド文字版の金属部のサビなどは、可能な限りきれいにいたします。" v-model="form4.outer_care" class="form-control" rows="8" maxlength="" v-bind:class="{ error_input: form4.errors.outer_care.length > 0 }"></textarea>
                                          <div v-if="form4.errors.outer_care.length > 0">
                                            <div class="error-text" v-for="(item, index) in form4.errors.outer_care" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">内側の手入れ</label>
                                          <textarea placeholder="記入例：内側についてはまず掃除をいたします。張られている弦で、サビやくすみがあり音に影響がでそうな弦やピンがあれば、それを磨いて良い状態にいたします。 " v-model="form4.inner_care" class="form-control" rows="8" maxlength="" v-bind:class="{ error_input: form4.errors.inner_care.length > 0 }"></textarea>
                                          <div v-if="form4.errors.inner_care.length > 0">
                                            <div class="error-text" v-for="(item, index) in form4.errors.inner_care" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">内部の調整</label>
                                          <textarea placeholder="記入例：フェルトなどの摩耗があれば、交換いたします。" v-model="form4.internal_adjustment" class="form-control" rows="8" maxlength="" v-bind:class="{ error_input: form4.errors.internal_adjustment.length > 0 }"></textarea>
                                          <div v-if="form4.errors.internal_adjustment.length > 0">
                                            <div class="error-text" v-for="(item, index) in form4.errors.internal_adjustment" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">整調</label>
                                          <textarea placeholder="記入例：鍵盤の高さ、深さ、重さは適切か、ネジに緩みはないかといった鍵盤の弾き心地に関わる基本調整をいたします。" v-model="form4.treasuring" class="form-control" rows="8" maxlength="" v-bind:class="{ error_input: form4.errors.treasuring.length > 0 }"></textarea>
                                          <div v-if="form4.errors.treasuring.length > 0">
                                            <div class="error-text" v-for="(item, index) in form4.errors.treasuring" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">整音</label>
                                          <textarea placeholder="記入例：ハンマーフェルトを削ったり針を刺すことで、豊かに響く音色にいたします。同時に音のバラつきがないように調整いたします。" v-model="form4.sound_adjustment" class="form-control" rows="8" maxlength="" v-bind:class="{ error_input: form4.errors.sound_adjustment.length > 0 }"></textarea>
                                          <div v-if="form4.errors.sound_adjustment.length > 0">
                                            <div class="error-text" v-for="(item, index) in form4.errors.sound_adjustment" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">調律</label>
                                          <textarea placeholder="記入例：音の狂いを直し、整えます。" v-model="form4.tuning" class="form-control" rows="8" maxlength="" v-bind:class="{ error_input: form4.errors.tuning.length > 0 }"></textarea>
                                          <div v-if="form4.errors.tuning.length > 0">
                                            <div class="error-text" v-for="(item, index) in form4.errors.tuning" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">その他</label>
                                          <textarea placeholder="記入例：音の狂いを直し、整えます。" v-model="form4.etc" class="form-control" rows="8" maxlength="" v-bind:class="{ error_input: form4.errors.etc.length > 0 }"></textarea>
                                          <div v-if="form4.errors.etc.length > 0">
                                            <div class="error-text" v-for="(item, index) in form4.errors.etc" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                                  <h5 class="mt-5 mb-4 pl-2">＜契約後の流れ＞</h5>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">STEP1.　ご注文</label>
                                          <div>
                                              このページにある「このピアノを購入する」ボタンを押して注文いただきます。
                                              ご注文確認後、お電話かメールをさせていただき、ご注文内容を確認いたします。
                                          </div>
                                      </div>
                                  </div>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">STEP2.　お支払い <span class="required_mark">必須</span></label>
                                          <textarea placeholder="" v-model="form4.about_payment" class="required form-control" rows="8" maxlength="" v-bind:class="{ error_input: form4.errors.about_payment.length > 0 }"></textarea>
                                          <div v-if="form4.errors.about_payment.length > 0">
                                            <div class="error-text" v-for="(item, index) in form4.errors.about_payment" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">STEP3.　出荷の準備 <span class="required_mark">必須</span></label>
                                          <textarea placeholder="" v-model="form4.about_shipping_preparation" class="required form-control" rows="8" maxlength="" v-bind:class="{ error_input: form4.errors.about_shipping_preparation.length > 0 }"></textarea>
                                          <div v-if="form4.errors.about_shipping_preparation.length > 0">
                                            <div class="error-text" v-for="(item, index) in form4.errors.about_shipping_preparation" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">STEP4.　納品日と調律、調整の打合せ <span class="required_mark">必須</span></label>
                                          <textarea placeholder="" v-model="form4.delivery_date_appointment" class="required form-control" rows="8" maxlength="" v-bind:class="{ error_input: form4.errors.delivery_date_appointment.length > 0 }"></textarea>
                                          <div v-if="form4.errors.delivery_date_appointment.length > 0">
                                            <div class="error-text" v-for="(item, index) in form4.errors.delivery_date_appointment" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">STEP5.　納品と調律、調整作業 <span class="required_mark">必須</span></label>
                                          <textarea placeholder="" v-model="form4.delivery_adjustment_work" class="required form-control" rows="8" maxlength="" v-bind:class="{ error_input: form4.errors.delivery_adjustment_work.length > 0 }"></textarea>
                                          <div v-if="form4.errors.delivery_adjustment_work.length > 0">
                                            <div class="error-text" v-for="(item, index) in form4.errors.delivery_adjustment_work" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                                  <h5 class="mt-5 mb-4 pl-2">＜トラブル＞</h5>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">万一のトラブルの際の対応について説明 <span class="required_mark">必須</span></label>
                                          <textarea placeholder="" v-model="form4.response_case_trouble" class="required form-control" rows="8" maxlength="" v-bind:class="{ error_input: form4.errors.response_case_trouble.length > 0 }"></textarea>
                                          <div v-if="form4.errors.response_case_trouble.length > 0">
                                            <div class="error-text" v-for="(item, index) in form4.errors.response_case_trouble" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                                  <h5 class="mt-5 mb-4 pl-2">＜販売できる地域について＞</h5>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <!--<label class="col-sm-12 control-label">性別  <span class="required_mark">必須</span></label>-->
                                          <div class="col-sm-10">
                                          <label class="checkbox-inline p-3">
                                              <input type="radio" v-model="form4.about_areas_sell" value="1">
                                              営業エリアのみ
                                          </label>
                                          <label class="checkbox-inline p-3">
                                              <input type="radio" v-model="form4.about_areas_sell" value="2">
                                              全国通販可能
                                          </label>
                                      </div>
                                  </div>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">補足説明（実際に販売できるエリアを限定されている方は、具体的にその地域も記述ください。）</label>
                                          <textarea placeholder="例：　営業エリア：埼玉県全域、東京都全域、神奈川県の北部　など" v-model="form4.explanation_about_area" class="form-control" rows="8" maxlength="" v-bind:class="{ error_input: form4.errors.explanation_about_area.length > 0 }"></textarea>
                                          <div v-if="form4.errors.explanation_about_area.length > 0">
                                            <div class="error-text" v-for="(item, index) in form4.errors.explanation_about_area" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                                  <h5 class="mt-5 mb-4 pl-2">＜試弾について＞</h5>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">試弾可能かどうか  <span class="required_mark">必須</span></label>
                                          <div class="col-sm-10">
                                          <label class="checkbox-inline p-3">
                                              <input type="radio" v-model="form4.about_test_bullet" value="1">
                                              試弾可能
                                          </label>
                                          <label class="checkbox-inline p-3">
                                              <input type="radio" v-model="form4.about_test_bullet" value="2">
                                              試弾不可
                                          </label>
                                      </div>
                                  </div>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">試弾必須かどうか  <span class="required_mark">必須</span></label>
                                          <div class="col-sm-10">
                                          <label class="checkbox-inline p-3">
                                              <input type="radio" v-model="form4.test_bullet_required" value="1">
                                              試弾必須
                                          </label>
                                          <label class="checkbox-inline p-3">
                                              <input type="radio" v-model="form4.test_bullet_required" value="2">
                                              試弾不要
                                          </label>
                                      </div>
                                  </div>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">試弾について説明</label>
                                          <textarea placeholder="" v-model="form4.explanation_about_test_bullet" class="form-control" rows="8" maxlength="" v-bind:class="{ error_input: form4.errors.explanation_about_test_bullet.length > 0 }"></textarea>
                                          <div v-if="form4.errors.explanation_about_test_bullet.length > 0">
                                            <div class="error-text" v-for="(item, index) in form4.errors.explanation_about_test_bullet" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>
                                  
                                  <h5 class="mt-5 mb-4 pl-2">＜送料とピアノ設置について＞</h5>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">送料 <span class="required_mark">必須</span></label>
                                          <input style="width: 200px;display: inline-block;" type="tel" v-model="form4.postage" class="required form-control" v-bind:class="{ error_input: form4.errors.postage.length > 0 }">　円～
                                          <div v-if="form4.errors.postage.length > 0">
                                            <div class="error-text" v-for="(item, index) in form4.errors.postage" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">送料とピアノ設置について詳細説明 <span class="required_mark">必須</span></label>
                                          <textarea placeholder="" v-model="form4.explanation_about_piano_installation" class="required form-control" rows="8" maxlength="" v-bind:class="{ error_input: form4.errors.explanation_about_piano_installation.length > 0 }"></textarea>
                                          <div v-if="form4.errors.explanation_about_piano_installation.length > 0">
                                            <div class="error-text" v-for="(item, index) in form4.errors.explanation_about_piano_installation" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                                  <h5 class="mt-5 mb-4 pl-2">＜配送ついて＞</h5>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">配送について詳細説明 <span class="required_mark">必須</span></label>
                                          <textarea placeholder="" v-model="form4.explanation_about_delivery" class="required form-control" rows="8" maxlength="" v-bind:class="{ error_input: form4.errors.explanation_about_delivery.length > 0 }"></textarea>
                                          <div v-if="form4.errors.explanation_about_delivery.length > 0">
                                            <div class="error-text" v-for="(item, index) in form4.errors.explanation_about_delivery" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                                  <h5 class="mt-5 mb-4 pl-2">＜保証内容ついて＞</h5>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">保証内容について詳細説明 <span class="required_mark">必須</span></label>
                                          <textarea placeholder="" v-model="form4.explanation_about_warranty_details" class="required form-control" rows="8" maxlength="" v-bind:class="{ error_input: form4.errors.explanation_about_warranty_details.length > 0 }"></textarea>
                                          <div v-if="form4.errors.explanation_about_warranty_details.length > 0">
                                            <div class="error-text" v-for="(item, index) in form4.errors.explanation_about_warranty_details" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                                  <h5 class="mt-5 mb-4 pl-2">＜返品と交換について＞</h5>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">返品交換可能かどうか  <span class="required_mark">必須</span></label>
                                          <div class="col-sm-10">
                                            <label class="checkbox-inline p-3">
                                                <input type="radio" v-model="form4.about_return" value="1">
                                                返品可能
                                            </label>
                                            <label class="checkbox-inline p-3">
                                                <input type="radio" v-model="form4.about_return" value="2">
                                                返品不可
                                            </label>
                                          </div>
                                          <div class="col-sm-10">
                                            <label class="checkbox-inline p-3">
                                                <input type="radio" v-model="form4.about_exchange" value="1">
                                                交換可能
                                            </label>
                                            <label class="checkbox-inline p-3">
                                                <input type="radio" v-model="form4.about_exchange" value="2">
                                                交換不可
                                            </label>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">返品交換について詳細説明 <span class="required_mark">必須</span></label>
                                          <textarea placeholder="" v-model="form4.explanation_about_return_exchange" class="required form-control" rows="8" maxlength="" v-bind:class="{ error_input: form4.errors.explanation_about_return_exchange.length > 0 }"></textarea>
                                          <div v-if="form4.errors.explanation_about_return_exchange.length > 0">
                                            <div class="error-text" v-for="(item, index) in form4.errors.explanation_about_return_exchange" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                                  <h5 class="mt-5 mb-4 pl-2">＜お支払いについて＞</h5>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <!--<label class="col-sm-12 control-label">返品交換可能かどうか  <span class="required_mark">必須</span></label>-->
                                          <div class="col-sm-10">
                                            <label class="checkbox-inline p-3">
                                                <input type="radio" v-model="form4.credit_payment" value="1">
                                                クレジットカード払い可能
                                            </label>
                                            <label class="checkbox-inline p-3">
                                                <input type="radio" v-model="form4.credit_payment" value="2">
                                                クレジットカード払い不可
                                            </label>
                                          </div>
                                          <div class="col-sm-10">
                                            <label class="checkbox-inline p-3">
                                                <input type="radio" v-model="form4.whether_pay_installments" value="1">
                                                分割払い
                                            </label>
                                            <label class="checkbox-inline p-3">
                                                <input type="radio" v-model="form4.whether_pay_installments" value="2">
                                                分割払い不可
                                            </label>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">支払いについての説明</label>
                                          <textarea placeholder="" v-model="form4.explanation_about_payment" class="form-control" rows="8" maxlength="" v-bind:class="{ error_input: form4.errors.explanation_about_payment.length > 0 }"></textarea>
                                          <div v-if="form4.errors.explanation_about_payment.length > 0">
                                            <div class="error-text" v-for="(item, index) in form4.errors.explanation_about_payment" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                                  <h5 class="mt-5 mb-4 pl-2">＜ご注意事項＞</h5>

                                  <div class="form-group">
                                      <div class="col-sm-12 px-1">
                                          <label class="col-sm-12 control-label">注意事項について詳細説明 <span class="required_mark">必須</span></label>
                                          <textarea placeholder="" v-model="form4.explanation_about_notes" class="required form-control" rows="8" maxlength="" v-bind:class="{ error_input: form4.errors.explanation_about_notes.length > 0 }"></textarea>
                                          <div v-if="form4.errors.explanation_about_notes.length > 0">
                                            <div class="error-text" v-for="(item, index) in form4.errors.explanation_about_notes" :key="index">{{ item }}</div>
                                          </div>
                                      </div>
                                  </div>

                              </div>
                          </div>
        
                          <div class="form-group">
                              <div class="b100 col-sm-12">
                                  <button type="button" class="bs100 btn btn-primary" @click="form4_submit()">完了</button>
                                  <!-- <input class="bs100 btn btn-primary" type="submit" value="次へ"> -->
                              </div>
                          </div>
        
                        </div>

                      </div>

                    </template>
                    <template v-if="String(user.input_status) == '4'">

                      <div class="card">
                        <!-- <div class="card-header">相談所　公開プロフィール情報登録</div> -->

                        <div class="card-body step1"> 
                          <!--<h4 class="mb-5">〇 STEP4.　各商品ページの共通情報</h4>-->
                          <div class="">
                              <!-- <div class="card-header"></div> -->
                              <div class="mb-5 text-center"> 
                                  基本情報の入力が完了しました。<br>
                                  この後は、マイページから本人確認をお願いいたします。
                              </div>

                              <div class="form-group">
                                  <div class="b100 col-sm-12">
                                      <button type="button" class="bs100 btn btn-primary" @click="page_reload()">マイページへ</button>
                                      <!-- <input class="bs100 btn btn-primary" type="submit" value="次へ"> -->
                                  </div>
                              </div>
                          </div>
                        </div>
                      </div>

                    </template>
                  </div>
                </div>
              </b-col>
            </b-row>
          </template>
        </template>
      </template>

      <!-- 管理者 メイン -->
      <template v-if="String(user.user_type) == '9'">
        <!-- 管理者 サイドメニュー -->
        <aside>
          <b-sidebar
            id="sidebar-backdrop"
            backdrop
            shadow
            no-header
            sidebar-class="border-right"
            width="250px"
          >
            <b-list-group flush>
              <b-list-group-item><a @click="c_switch(1)">メインページ</a></b-list-group-item>
              <b-list-group-item><a @click="c_switch(2)">メッセージ</a></b-list-group-item>
              <b-list-group-item><a @click="c_switch(3)">ユーザ管理</a></b-list-group-item>
              <b-list-group-item><a @click="c_switch(4)">請求管理</a></b-list-group-item>
              <b-list-group-item><a @click="c_switch(5)">申込管理</a></b-list-group-item>
              <b-list-group-item><a @click="c_switch(6)">レビュー管理</a></b-list-group-item>
              <b-list-group-item><a @click="c_switch(7)">メッセージ管理</a></b-list-group-item>
              <b-list-group-item><a @click="c_switch(8)">メルマガ管理</a></b-list-group-item>
              <b-list-group-item><a @click="c_switch(9)">コメント管理</a></b-list-group-item>
              <b-list-group-item><a @click="c_switch(10)">記事管理</a></b-list-group-item>
            </b-list-group>
          </b-sidebar>
        </aside>
        <div class="row m-0">
            <div class="side-bar col-md-3 d-pc">
              <div>
                <ul class="sidenav">
                  <li><a v-bind:class="{ active: component_switch == 1 }" class="" href="javascript:void(0);" @click="c_switch(1)">メインページ</a></li>
                  <li><a v-bind:class="{ active: component_switch == 2 }" class="" href="javascript:void(0);" @click="c_switch(2)">運営メッセージ</a></li>
                  <li><a v-bind:class="{ active: component_switch == 3 }" class="" href="javascript:void(0);" @click="c_switch(3)">ユーザ管理</a></li>
                  <li><a v-bind:class="{ active: component_switch == 4 }" class="" href="javascript:void(0);" @click="c_switch(4)">請求管理</a></li>
                  <li><a v-bind:class="{ active: component_switch == 5 }" class="" href="javascript:void(0);" @click="c_switch(5)">申込管理</a></li>
                  <li><a v-bind:class="{ active: component_switch == 6 }" class="" href="javascript:void(0);" @click="c_switch(6)">レビュー管理</a></li>
                  <li><a v-bind:class="{ active: component_switch == 7 }" class="" href="javascript:void(0);" @click="c_switch(7)">メッセージ管理</a></li>
                  <li><a v-bind:class="{ active: component_switch == 8 }" class="" href="javascript:void(0);" @click="c_switch(8)">メルマガ管理</a></li>
                  <li><a v-bind:class="{ active: component_switch == 9 }" class="" href="javascript:void(0);" @click="c_switch(9)">コメント管理</a></li>
                  <li><a v-bind:class="{ active: component_switch == 10 }" class="" href="javascript:void(0);" @click="c_switch(10)">記事管理</a></li>
                </ul>
              </div>
            </div>
            <div class="main-contents col-md-9">
              <div>
                <admin-main v-if="component_switch==1" :user="user"></admin-main>
                <admin-message v-if="component_switch==2" :user="user"></admin-message>
                <admin-user v-if="component_switch==3" :user="user"></admin-user>
                <admin-billing v-if="component_switch==4" :user="user"></admin-billing>
                <admin-application v-if="component_switch==5" :user="user"></admin-application>
                <admin-review v-if="component_switch==6" :user="user"></admin-review>
                <admin-messagemanager v-if="component_switch==7" :user="user"></admin-messagemanager>
                <admin-mail v-if="component_switch==8" :user="user"></admin-mail>
                <admin-comment v-if="component_switch==9" :user="user"></admin-comment>
                <admin-article v-if="component_switch==10" :user="user"></admin-article>
                <admin-articledetail v-if="component_switch==11" :user="user"></admin-articledetail>
              </div>
            </div>
        </div>
      </template>

    </b-container>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import VueJsPaginate from "vuejs-paginate";
import axios from 'axios';

// 販売者コンポーネント
import SellMain from './mypage/seller/main.vue' // メインページ
import SellProduct from './mypage/seller/product.vue' // 商品管理
import SellProfile from './mypage/seller/profile.vue' // プロフィール登録情報
import SellBuy from './mypage/seller/buy.vue' // 購入申し込み管理
import SellMessage from './mypage/seller/message.vue' // メッセージ管理
import SellComment from './mypage/seller/comment.vue' // コメント管理
import SellPayment from './mypage/seller/payment.vue' // 支払い管理
import SellTestBullet from './mypage/seller/test_bullet.vue' // 試弾申し込み管理
import SellStaff from './mypage/seller/staff.vue' // スタッフ管理
import SellIdentification from './mypage/seller/identification.vue' // 本人確認
import SellReview from './mypage/seller/review.vue' // レビュー

// 一般コンポーネント
import BuyMain from './mypage/buyer/main.vue' // メインページ
import BuyProfile from './mypage/buyer/profile.vue' // プロフィール登録情報
import BuyBuy from './mypage/buyer/buy.vue' // 購入申し込み管理
import BuyTestBullet from './mypage/buyer/test_bullet.vue' // 試弾申し込み管理
import BuyMessage from './mypage/buyer/message.vue' // メッセージ管理
import BuyReview from './mypage/buyer/review.vue' // レビュー
import BuyFavorite from './mypage/buyer/favorite.vue' // お気に入り
import BuyComment from './mypage/buyer/comment.vue' // コメント管理

// 管理者コンポーネント
import AdminMain from './mypage/admin/main.vue' // メインページ
import AdminMessage from './mypage/admin/message.vue' // メッセージ
import AdminUser from './mypage/admin/user.vue' // ユーザ管理
import AdminBilling from './mypage/admin/billing.vue' // 4.請求管理（未着手）
import AdminApplication from './mypage/admin/application.vue' // 5.申し込み管理（未着手）
import AdminReview from './mypage/admin/review.vue' // 6.レビュー管理（未着手）
import AdminMessageManager from './mypage/admin/message_manager.vue' // 7.メッセージ管理（未着手）
import AdminMail from './mypage/admin/mail.vue' // 8.メルマガ（未着手）
import AdminComment from './mypage/admin/comment.vue' // 9.コメント管理（未着手）
import AdminArticle from './mypage/admin/article.vue' // 10.記事管理（未着手）これから対応
import AdminArticleDetail from './mypage/admin/article_detail.vue' // 10.記事管理（未着手）これから対応

export default {
  name: 'Mypage',
  components: {
    'vuejs-paginate': VueJsPaginate,
    'seller-main': SellMain,
    'seller-profile': SellProfile,
    'seller-product': SellProduct,
    'seller-buy': SellBuy,
    'seller-message': SellMessage,
    'seller-comment': SellComment,
    'seller-payment': SellPayment,
    'seller-testbullet': SellTestBullet,
    'seller-staff': SellStaff,
    'seller-identification': SellIdentification,
    'seller-review': SellReview,
    'buyer-main': BuyMain,
    'buyer-profile': BuyProfile,
    'buyer-buy': BuyBuy,
    'buyer-testbullet': BuyTestBullet,
    'buyer-message': BuyMessage,
    'buyer-review': BuyReview,
    'buyer-favorite': BuyFavorite,
    'buyer-comment': BuyComment,
    'admin-main': AdminMain,
    'admin-message': AdminMessage,
    'admin-user': AdminUser,
    'admin-billing': AdminBilling,
    'admin-application': AdminApplication,
    'admin-review': AdminReview,
    'admin-messagemanager': AdminMessageManager,
    'admin-mail': AdminMail,
    'admin-comment': AdminComment,
    'admin-article': AdminArticle,
    'admin-articledetail': AdminArticleDetail,
  },
  data() {
    return {
      component_switch: 1,
			isError: false,
      user: null,

			form1: { // 法人
				errors: {
          legal_person: [],
          corp_name: [],
          corp_representative: [],
          corp_postalcode: [],
          corp_address: [],
          corp_phone_number: [],
          hp_url: [],
				},
        legal_person: 0,
        corp_name: "",
        corp_representative: "",
        corp_postalcode: "",
        corp_address: "",
        corp_phone_number: "",
        hp_url: "",
      },

			form2: { // ピアノ販売者 アカウント
				errors: {
          blog_url: [],
          store_name: [],
          last_name: [],
          first_name: [],
          phonetic_last_name: [],
          phonetic_first_name: [],
          postal_code: [],
          region: [],
          address_1: [],
          address_2: [],
          phone: [],
          gender: [],
          old: [],
				},
        blog_url: "",
        store_name: "",
        last_name: "",
        first_name: "",
        phonetic_last_name: "",
        phonetic_first_name: "",
        postal_code: "",
        region: "",
        address_1: "",
        address_2: "",
        phone: "",
        gender: 1,
        old: null,
      },

      imageSet: false,
			form3: { // 画像・その他
				errors: {
          name: [],
          image: [],
          slogan: [],
          Introduction: [],
          promiss: [],
        },
        name1: "",
        image1: null,
        name2: "",
        image2: null,
        name3: "",
        image3: null,
        name4: "",
        image4: null,
        name5: "",
        image5: null,
        name6: "",
        image6: null,
        name7: "",
        image7: null,
        name8: "",
        image8: null,
        name9: "",
        image9: null,
        name10: "",
        image10: null,
        slogan: "",
        Introduction: "",
        promiss: "",
      },

			form4: { // 共通情報
				errors: {
          maintenance_policy: [],
          outer_care: [],
          inner_care: [],
          internal_adjustment: [],
          treasuring: [],
          sound_adjustment: [],
          tuning: [],
          etc: [],

          about_payment: [],
          about_shipping_preparation: [],
          delivery_date_appointment: [],
          delivery_adjustment_work: [],
          response_case_trouble: [],
          about_areas_sell: [],
          explanation_about_area: [],

          about_test_bullet: [],
          test_bullet_required: [],
          explanation_about_test_bullet: [],

          postage: [],
          explanation_about_piano_installation: [],
          explanation_about_delivery: [],
          explanation_about_warranty_details: [],

          about_return: [],
          about_exchange: [],
          explanation_about_return_exchange: [],

          credit_payment: [],
          whether_pay_installments: [],
          explanation_about_payment: [],

          explanation_about_notes: [],
        },
        maintenance_policy: "",
        outer_care: "",
        inner_care: "",
        internal_adjustment: "",
        treasuring: "",
        sound_adjustment: "",
        tuning: "",
        etc: "",

        about_payment: "",
        about_shipping_preparation: "",
        delivery_date_appointment: "",
        delivery_adjustment_work: "",
        response_case_trouble: "",
        about_areas_sell: 1,
        explanation_about_area: "",

        about_test_bullet: 1,
        test_bullet_required: 1,
        explanation_about_test_bullet: "",

        postage: null,
        explanation_about_piano_installation: "",
        explanation_about_delivery: "",
        explanation_about_warranty_details: "",

        about_return: 1,
        about_exchange: 1,
        explanation_about_return_exchange: "",

        credit_payment: 1,
        whether_pay_installments: 1,
        explanation_about_payment: "",

        explanation_about_notes: "",
      },

    }
  },
  computed: {
  },
  methods: {
    /*
    * user show
    */
    async current_user() {
      this.$store.dispatch('user/current_user')
      .then(res => {
        this.user = res.data.users;
        console.log(this.user);
      }, error => {
        // バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
        console.log(error);
        // if ('error' in error.response.data) {
        //   alert(error.response.data['error']);
        //   window.scrollTo({
        //     top: 0,
        //   });
        // }
      });
    },
    // 初回販売者更新処理
    async init_update_user(update_users) {
      this.$store.dispatch('user/init_update_user', {
        users: update_users['users'],
      }).then(res => {
        console.log(res);
        console.log(update_users);
        if ( String(update_users['users']['input_status']) == 0 ) {
          this.user.input_status = 1;
        } else if ( String(update_users['users']['input_status']) == 1 ) {
          this.user.input_status = 2;
        } else if ( String(update_users['users']['input_status']) == 2 ) {
          this.user.input_status = 3;
        } else if ( String(update_users['users']['input_status']) == 3 ) {
          this.user.input_status = 4; // 完了
        }
        window.scrollTo({
          top: 0,
        });
      }, error => {
        // バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
        console.log(error.response.data);
        if ('error' in error.response.data) {
          alert(error.response.data['error']);
          this.isError = true;
          window.scrollTo({
            top: 0,
          });
        }
      });
      return false;
    },

    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    onImageChange1(e) { this.onImageChange(1, e); },
    onImageChange2(e) { this.onImageChange(2, e); },
    onImageChange3(e) { this.onImageChange(3, e); },
    onImageChange4(e) { this.onImageChange(4, e); },
    onImageChange5(e) { this.onImageChange(5, e); },
    onImageChange6(e) { this.onImageChange(6, e); },
    onImageChange7(e) { this.onImageChange(7, e); },
    onImageChange8(e) { this.onImageChange(8, e); },
    onImageChange9(e) { this.onImageChange(9, e); },
    onImageChange10(e) { this.onImageChange(10, e); },
    onImageChange(target, e) {
      const images = e.target.files || e.dataTransfer.files
      this.getBase64(images[0]).then(image => {
        const originalImg = new Image()
        originalImg.src = image
        originalImg.onload = () => {
          const resizedCanvas = this.createResizedCanvasElement(originalImg)
          const resizedBase64 = resizedCanvas.toDataURL(images[0].type)
          if ( target == 1 ) { this.form3.image1 = resizedBase64 }
          if ( target == 2 ) { this.form3.image2 = resizedBase64 }
          if ( target == 3 ) { this.form3.image3 = resizedBase64 }
          if ( target == 4 ) { this.form3.image4 = resizedBase64 }
          if ( target == 5 ) { this.form3.image5 = resizedBase64 }
          if ( target == 6 ) { this.form3.image6 = resizedBase64 }
          if ( target == 7 ) { this.form3.image7 = resizedBase64 }
          if ( target == 8 ) { this.form3.image8 = resizedBase64 }
          if ( target == 9 ) { this.form3.image9 = resizedBase64 }
          if ( target == 10 ) { this.form3.image10 = resizedBase64 }
          this.imageSet = true;
        }
      }).catch(error =>
        alert('画像処理に失敗しました。再度画像を選択してください。')
      )
    },
    uploadImage1() { this.$refs.input1.click(); },
    uploadImage2() { this.$refs.input2.click(); },
    uploadImage3() { this.$refs.input3.click(); },
    uploadImage4() { this.$refs.input4.click(); },
    uploadImage5() { this.$refs.input5.click(); },
    uploadImage6() { this.$refs.input6.click(); },
    uploadImage7() { this.$refs.input7.click(); },
    uploadImage8() { this.$refs.input8.click(); },
    uploadImage9() { this.$refs.input9.click(); },
    uploadImage10() { this.$refs.input10.click(); },
    createResizedCanvasElement(originalImg) {
      const originalImgWidth = originalImg.width
      const orifinalImgHeight = originalImg.height
      const [resizedWidth, resizedHeight] = this.resizeWidthAndHeight(originalImgWidth, orifinalImgHeight)
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      canvas.width = resizedWidth
      canvas.height = resizedHeight
      ctx.drawImage(originalImg, 0, 0, resizedWidth, resizedHeight)
      return canvas
    },
    resizeWidthAndHeight(width, height) {
      const MAX_WIDTH = 800
      const MAX_HEIGHT = 600
      if (width > height) {
        if (width > MAX_WIDTH) {
          height *= MAX_WIDTH / width
          width = MAX_WIDTH
        }
      } else {
        if (height > MAX_HEIGHT) {
          width *= MAX_HEIGHT / height
          height = MAX_HEIGHT
        }
      }
      return [width, height]
    },

    form1_submit() {
      let update_user = {};
      this.isError = false;
			this.form1.errors.legal_person = [];
			this.form1.errors.corp_name = [];
			this.form1.errors.corp_representative = [];
			this.form1.errors.corp_postalcode = [];
			this.form1.errors.corp_address = [];
			this.form1.errors.corp_phone_number = [];
			this.form1.errors.hp_url = [];
      if ( String(this.form1.legal_person) == '1' ) {
        if (!this.form1.corp_name) {
          this.form1.errors.corp_name.push('法人(企業)名が入力されていません');
          this.isError = true;
        }
        if (!this.form1.corp_representative) {
          this.form1.errors.corp_representative.push('法人代表者(責任者)の氏名が入力されていません');
          this.isError = true;
        }
        if (!this.form1.corp_postalcode) {
          this.form1.errors.corp_postalcode.push('郵便番号が入力されていません');
          this.isError = true;
        } else {
          let check_num = String(this.form1.corp_postalcode).replace(/[^0-9]/g, '');
          if (check_num == '') {
            this.form1.errors.corp_postalcode.push('郵便番号が正しく入力されていません');
            this.isError = true;
          }
        }
        if (!this.form1.corp_address) {
          this.form1.errors.corp_address.push('住所が入力されていません');
          this.isError = true;
        }
        if (this.form1.corp_phone_number) {
          let check_num = String(this.form1.corp_phone_number).replace(/[^0-9]/g, '');
          if (check_num == '') {
            this.form1.errors.corp_phone_number.push('電話番号が正しく入力されていません');
            this.isError = true;
          }
        }
      }
      if (this.isError) {
        window.scrollTo({
          top: 0,
        });
      } else {
        update_user['users'] = this.form1;
        update_user['users']['input_status'] = 0;
        this.init_update_user(update_user);
      }
      return false;
    },
    form2_submit() {
      let update_user = {};
      this.isError = false;
			this.form2.errors.store_name = [];
			this.form2.errors.postal_code = [];
			this.form2.errors.region = [];
			this.form2.errors.address_1 = [];
			this.form2.errors.address_2 = [];
			this.form2.errors.phone = [];
			this.form2.errors.last_name = [];
			this.form2.errors.first_name = [];
			this.form2.errors.phonetic_last_name = [];
			this.form2.errors.phonetic_first_name = [];
			this.form2.errors.old = [];
      if (!this.form2.store_name) {
        this.form2.errors.store_name.push('ピアノ販売業の屋号が入力されていません');
        this.isError = true;
      }
      if (!this.form2.postal_code) {
        this.form2.errors.postal_code.push('郵便番号が入力されていません');
        this.isError = true;
      } else {
        let check_num = String(this.form2.postal_code).replace(/[^0-9]/g, '');
        if (check_num == '') {
          this.form2.errors.postal_code.push('郵便番号が正しく入力されていません');
          this.isError = true;
        }
      }
      if (!this.form2.region) {
        this.form2.errors.region.push('都道府県が入力されていません');
        this.isError = true;
      }
      if (!this.form2.address_1) {
        this.form2.errors.address_1.push('住所１　(市区町村)が入力されていません');
        this.isError = true;
      }
      if (!this.form2.address_2) {
        this.form2.errors.address_2.push('住所２　(番地、建物名)が入力されていません');
        this.isError = true;
      }
      if (this.form2.phone) {
        let check_num = String(this.form2.phone).replace(/[^0-9]/g, '');
        if (check_num == '') {
          this.form2.errors.phone.push('電話番号が正しく入力されていません');
          this.isError = true;
        }
      }
      if (!this.form2.last_name) {
        this.form2.errors.last_name.push('姓が入力されていません');
        this.isError = true;
      }
      if (!this.form2.first_name) {
        this.form2.errors.first_name.push('名が入力されていません');
        this.isError = true;
      }
      if (!this.form2.phonetic_last_name) {
        this.form2.errors.phonetic_last_name.push('セイが入力されていません');
        this.isError = true;
      }
      if (!this.form2.phonetic_first_name) {
        this.form2.errors.phonetic_first_name.push('メイが入力されていません');
        this.isError = true;
      }
      if (!this.form2.old) {
        this.form2.errors.old.push('生年月日が入力されていません');
        this.isError = true;
      }
      if (this.isError) {
        window.scrollTo({
          top: 0,
        });
      } else {
        update_user['users'] = this.form2;
        update_user['users']['input_status'] = 1;
        this.init_update_user(update_user);
      }
      return false;
    },
    form3_submit() {
      let update_user = {};
      this.isError = false;
			this.form3.errors.slogan = [];
			this.form3.errors.Introduction = [];
			this.form3.errors.promiss = [];
			this.form3.errors.image = [];
      if (!this.imageSet) {
        this.form3.errors.image.push('画像は最低１つ選択してください');
        this.isError = true;
      }
      if (!this.form3.slogan) {
        this.form3.errors.slogan.push('一言アピールが入力されていません');
        this.isError = true;
      }
      if (!this.form3.Introduction) {
        this.form3.errors.Introduction.push('事業紹介が入力されていません');
        this.isError = true;
      }
      if (!this.form3.promiss) {
        this.form3.errors.promiss.push('購入された方への約束についてが入力されていません');
        this.isError = true;
      }
      if (this.isError) {
        window.scrollTo({
          top: 0,
        });
      } else {
        update_user['users'] = this.form3;
        update_user['users']['input_status'] = 2;
        this.init_update_user(update_user);
      }
      return false;
    },
    form4_submit() {
      // maintenance_policy: "整備内容の方針、概要",
      // outer_care: "外側の手入れ",
      // inner_care: "内側の手入れ",
      // internal_adjustment: "内部の調整",
      // treasuring: "整調",
      // sound_adjustment: "整音",
      // tuning: "調律",
      // etc: "その他",

      // about_test_bullet: null, 試弾可能かどうか
      // test_bullet_required: null, 試弾必須かどうか
      // explanation_about_test_bullet: "試弾について説明",

      // credit_payment: null,
      // whether_pay_installments: null,
      // explanation_about_payment: "支払いについての説明",

      let update_user = {};
      this.isError = false;

      // about_payment: "お支払い", 必須
      // about_shipping_preparation: "出荷の準備", 必須
      // delivery_date_appointment: "納品日と調律、調整の打合せ", 必須
      // delivery_adjustment_work: "納品と調律、調整作業", 必須
      // response_case_trouble: "万一のトラブルの際の対応について説明", 必須
      // about_areas_sell: null, 販売できる地域について
      // explanation_about_area: "補足説明", 
			this.form4.errors.about_payment = [];
			this.form4.errors.about_shipping_preparation = [];
			this.form4.errors.delivery_date_appointment = [];
			this.form4.errors.delivery_adjustment_work = [];
			this.form4.errors.response_case_trouble = [];

      // postage: null, 送料 必須
      // explanation_about_piano_installation: "送料とピアノ設置について詳細説明", 必須
      // explanation_about_delivery: "配送について詳細説明", 必須
      // explanation_about_warranty_details: "保証内容について詳細説明", 必須
			this.form4.errors.postage = [];
			this.form4.errors.explanation_about_piano_installation = [];
			this.form4.errors.explanation_about_delivery = [];
			this.form4.errors.explanation_about_warranty_details = [];

      // about_return: null,
      // about_exchange: null,
      // explanation_about_return_exchange: "返品交換について詳細説明", 必須
			this.form4.errors.explanation_about_return_exchange = [];

      // explanation_about_notes: "注意事項について詳細説明", 必須
			this.form4.errors.explanation_about_notes = [];

      if (!this.form4.about_payment) {
        this.form4.errors.about_payment.push('お支払いが入力されていません');
        this.isError = true;
      }
      if (!this.form4.about_shipping_preparation) {
        this.form4.errors.about_shipping_preparation.push('出荷の準備が入力されていません');
        this.isError = true;
      }
      if (!this.form4.delivery_date_appointment) {
        this.form4.errors.delivery_date_appointment.push('納品日と調律、調整の打合せが入力されていません');
        this.isError = true;
      }
      if (!this.form4.delivery_adjustment_work) {
        this.form4.errors.delivery_adjustment_work.push('納品と調律、調整作業が入力されていません');
        this.isError = true;
      }
      if (!this.form4.response_case_trouble) {
        this.form4.errors.response_case_trouble.push('万一のトラブルの際の対応について説明が入力されていません');
        this.isError = true;
      }

      if (!this.form4.postage) {
        this.form4.errors.postage.push('送料が入力されていません');
        this.isError = true;
      } else {
        let check_num = String(this.form4.postage).replace(/[^0-9]/g, '');
        if (check_num == '') {
          this.form4.errors.postage.push('送料が正しく入力されていません');
          this.isError = true;
        }        
      }
      if (!this.form4.explanation_about_piano_installation) {
        this.form4.errors.explanation_about_piano_installation.push('送料とピアノ設置について詳細説明が入力されていません');
        this.isError = true;
      }
      if (!this.form4.explanation_about_delivery) {
        this.form4.errors.explanation_about_delivery.push('配送について詳細説明が入力されていません');
        this.isError = true;
      }
      if (!this.form4.explanation_about_warranty_details) {
        this.form4.errors.explanation_about_warranty_details.push('保証内容について詳細説明が入力されていません');
        this.isError = true;
      }

      if (!this.form4.explanation_about_return_exchange) {
        this.form4.errors.explanation_about_return_exchange.push('返品交換について詳細説明が入力されていません');
        this.isError = true;
      }

      if (!this.form4.explanation_about_notes) {
        this.form4.errors.explanation_about_notes.push('注意事項について詳細説明が入力されていません');
        this.isError = true;
      }

      if (this.isError) {
        window.scrollTo({
          top: 0,
        });
      } else {
        update_user['users'] = this.form4;
        update_user['users']['input_status'] = 3;
        this.init_update_user(update_user);
      }
      return false;
    },
    page_reload() {
      location.reload();
    },
    c_switch(page) {
      // this.component_switch = page;
      // location.href = location.href.split("?")[0] + '?page='+page;
      this.$router.push({path: '/mypage', query: {page: page}});
      this.component_switch = Number(this.$route.query.page);
    },
  },
  created() {
    if( this.$route.query.page != null && this.$route.query.page != undefined && String(this.$route.query.page) != "" ){
      this.component_switch = Number(this.$route.query.page);
    } else {
      // location.href = location.href.split("?")[0] + '?page=1';
      this.$router.push({path: '/mypage', query: {page: 1}});
      // this.component_switch = Number(1);
    }
    this.current_user();
    // if ( window.innerWidth <= 575 ) { // スマホの場合、非表示
    //   this.display_tab = 0;
    // }
  },
  watch: {
    'form2.postal_code': function(val){
      if (val.length > 6) {
        let _this = this
        new YubinBango.Core(val, function(addr) {
          if (_this.form2.region==''||_this.form2.region==null) {
            _this.form2.region = addr.region // 都道府県
          }
          if (_this.form2.address_1==''||_this.form2.address_1==null) {
            _this.form2.address_1 = addr.locality  // 市区町村
          }
          if (_this.form2.address_2==''||_this.form2.address_2==null) {
            _this.form2.address_2 = addr.street  // 町域
          }
        })
      }
    },
    'form1.corp_postalcode': function(val){
      if (val.length > 6) {
        let _this = this
        new YubinBango.Core(val, function(addr) {
          if (_this.form1.corp_address==''||_this.form1.corp_address==null) {
            _this.form1.corp_address = addr.region+addr.locality+addr.street
          }
        })
      }
    },
    $route (to, from) {
      console.log(to.query);
      console.log(from.query);
      if ( to.query.page != from.query.page ) {
        this.component_switch = Number(to.query.page);
      }
      if ( String(to.query.anc) == 'f3' && to.query.anc != from.query.anc ) {
  			this.$nextTick(function() {
          document.getElementById(String(to.query.anc)).scrollIntoView(true)
        });
      }
    }
  }

}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Mypage.vue